/* Lane Y (2 Oct 2026): cross-brand alternatives on product pages (sections/upsb-pdp-alternatives.liquid).
   Discontinued pages: the dialog opens once per session per product on arrival (not while another dialog or drawer is
   open; never on a refurbished listing), and from any [data-upsb-alt-open] button. Focus is trapped while it is open,
   ESC / X / "Keep reading" / backdrop close it, focus returns to where it was. Events go through UPSBMeasure (E.11). */
(function () {
  'use strict';
  var root = document.querySelector('[data-upsb-alt]');
  if (!root) return;
  var page = root.getAttribute('data-page') === 'discontinued' ? 'discontinued' : 'current';
  var locale = root.getAttribute('data-locale') === 'fr' ? 'fr' : 'en';
  var measure = null;
  try { if (window.UPSBMeasure) measure = window.UPSBMeasure.forElement(root, 'product', locale); } catch (e) { measure = null; }
  function emit(name, fields, key) { try { if (measure) measure.emit(name, fields, key); } catch (e) { /* never break the page */ } }

  // Clicks on any card, inline or in the dialog.
  root.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-upsb-alt-act]') : null;
    if (!el || !root.contains(el)) return;
    var card = el.closest('[data-upsb-alt-pos]');
    var list = el.closest('[data-upsb-alt-list]');
    var pos = card ? parseInt(card.getAttribute('data-upsb-alt-pos'), 10) : 0;
    emit('upsb_alt_clicked', {
      action: el.getAttribute('data-upsb-alt-act'),
      placement: list && list.getAttribute('data-placement') === 'dialog' ? 'dialog' : 'inline',
      page: page, position: isNaN(pos) ? 0 : pos
    });
  });

  if (page !== 'discontinued') return;
  var dialog = root.querySelector('[data-upsb-alt-dialog]');
  var back = root.querySelector('[data-upsb-alt-back]');
  var inlineList = root.querySelector('[data-upsb-alt-list][data-placement="inline"]');
  var dialogList = dialog && dialog.querySelector('[data-upsb-alt-list][data-placement="dialog"]');
  if (!dialog || !back || !inlineList || !dialogList) return;

  // One source of cards: the dialog shows a copy of the inline list (ids are not used inside the cards).
  dialogList.innerHTML = inlineList.innerHTML;
  var shown = dialogList.querySelectorAll('[data-upsb-alt-pos]').length;

  // Every opener on the page (the notice in the buy area) learns that alternatives exist.
  var openers = document.querySelectorAll('[data-upsb-alt-open]');
  Array.prototype.forEach.call(openers, function (b) {
    b.hidden = false;
    b.setAttribute('aria-haspopup', 'dialog');
    b.addEventListener('click', function () { open('button'); });
  });

  var lastFocus = null;
  var isOpen = false;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])';
  function focusables() {
    return Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }
  function onKey(e) {
    if (!isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close('escape'); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  }
  function onFocusIn(e) { if (isOpen && !dialog.contains(e.target)) { var f = focusables(); if (f.length) f[0].focus(); } }

  function open(trigger) {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    back.hidden = false; dialog.hidden = false;
    document.documentElement.classList.add('upsb-altd-open');
    document.addEventListener('keydown', onKey, true);
    document.addEventListener('focusin', onFocusIn, true);
    var x = dialog.querySelector('[data-upsb-alt-close="close"]');
    if (x) { try { x.focus({ preventScroll: true }); } catch (e) { x.focus(); } }
    try { sessionStorage.setItem('upsbAltSeen:' + root.getAttribute('data-handle'), '1'); } catch (e) { /* private mode */ }
    emit('upsb_alt_opened', { trigger: trigger, page: page, shown_count: shown });
  }
  function close(reason) {
    if (!isOpen) return;
    isOpen = false;
    dialog.hidden = true; back.hidden = true;
    document.documentElement.classList.remove('upsb-altd-open');
    document.removeEventListener('keydown', onKey, true);
    document.removeEventListener('focusin', onFocusIn, true);
    if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); }
    }
    emit('upsb_alt_closed', { reason: reason, page: page });
  }
  Array.prototype.forEach.call(dialog.querySelectorAll('[data-upsb-alt-close]'), function (b) {
    b.addEventListener('click', function () { close(b.getAttribute('data-upsb-alt-close') === 'keep' ? 'keep' : 'close'); });
  });
  back.addEventListener('click', function () { close('backdrop'); });

  // Arrival: once per session per product, never over another open dialog or drawer.
  var force = /[?&]upsb_alt=1(&|$)/.test(window.location.search || '');
  var seen = false;
  try { seen = sessionStorage.getItem('upsbAltSeen:' + root.getAttribute('data-handle')) === '1'; } catch (e) { seen = false; }
  if (root.getAttribute('data-auto') !== 'true' && !force) return;
  // Arriving from a card's "See alternatives" link lands on the inline cards already: no pop-up on top of them.
  if (window.location.hash === '#upsb-available-now' && !force) return;
  if (seen && !force) return;
  function busy() {
    if (document.documentElement.classList.contains('upsb-altd-open')) return true;
    if (document.body && /\boverflow-hidden\b/.test(document.body.className)) return true; // Dawn drawers and menus
    // Dawn keeps its closed dialogs (search, cart notification, media) in the layout, so a dialog counts as open only
    // when it is the element actually painted at its own centre point.
    var dlg = document.querySelectorAll('[role="dialog"],dialog[open],.upsb-sm[data-open="1"]');
    for (var i = 0; i < dlg.length; i++) {
      var el = dlg[i];
      if (el === dialog || el.hidden) continue;
      var r = el.getBoundingClientRect();
      if (r.width < 2 || r.height < 2) continue;
      var cx = Math.min(Math.max(r.left + r.width / 2, 0), window.innerWidth - 1);
      var cy = Math.min(Math.max(r.top + r.height / 2, 0), window.innerHeight - 1);
      var hit = document.elementFromPoint(cx, cy);
      if (hit && el.contains(hit)) return true;
    }
    return false;
  }
  var tries = 0;
  function attempt() {
    tries += 1;
    if (!busy()) { open('auto'); return; }
    if (tries < 3) setTimeout(attempt, 4000);
  }
  setTimeout(attempt, 1200);
})();
